import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/unlock.png'
import _imports_1 from '@/assets/delay_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-61f61593"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty-wrap"
}
const _hoisted_2 = { class: "sub-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "places" }, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  key: 0,
  class: "no-permission-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "no-permission-img",
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "no-permission-title" }
const _hoisted_9 = { class: "no-permission-desc" }
const _hoisted_10 = { class: "top-section" }
const _hoisted_11 = {
  key: 1,
  class: "no-permission-mask"
}
const _hoisted_12 = {
  key: 0,
  class: "info-panel"
}
const _hoisted_13 = { class: "info-block" }
const _hoisted_14 = { class: "info-title" }
const _hoisted_15 = {
  key: 0,
  class: "tag-list"
}
const _hoisted_16 = {
  key: 1,
  class: "profile-text"
}
const _hoisted_17 = { class: "profit-block" }
const _hoisted_18 = { class: "info-title" }
const _hoisted_19 = { class: "profit-card" }
const _hoisted_20 = { class: "profit-main" }
const _hoisted_21 = { class: "profit-label" }
const _hoisted_22 = { class: "profit-stats" }
const _hoisted_23 = { class: "stat-item" }
const _hoisted_24 = { class: "stat-label" }
const _hoisted_25 = { class: "stat-item" }
const _hoisted_26 = { class: "stat-value" }
const _hoisted_27 = { class: "stat-label" }
const _hoisted_28 = { class: "stat-item" }
const _hoisted_29 = { class: "stat-value" }
const _hoisted_30 = { class: "stat-label" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "bottom-section" }
const _hoisted_33 = { class: "table-panel" }
const _hoisted_34 = { class: "table-header" }
const _hoisted_35 = {
  key: 0,
  class: "loading-wrap"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-dot" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "native-table-wrap native-table-wrap--empty" }
const _hoisted_39 = { class: "native-table" }
const _hoisted_40 = { style: {"width":"40px"} }
const _hoisted_41 = { class: "history-empty" }
const _hoisted_42 = { class: "native-table" }
const _hoisted_43 = { style: {"width":"40px"} }
const _hoisted_44 = ["onDblclick"]
const _hoisted_45 = { class: "center" }
const _hoisted_46 = { class: "stock-name" }
const _hoisted_47 = { class: "stock-code-row" }
const _hoisted_48 = {
  key: 0,
  src: _imports_1,
  class: "delay-tag",
  alt: "延时"
}
const _hoisted_49 = { class: "symbol-text" }
const _hoisted_50 = { class: "center muted" }
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  colspan: "4",
  class: "center muted"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  colspan: "4",
  class: "center muted"
}
const _hoisted_56 = {
  key: 0,
  class: "no-permission-mask"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingMask = _resolveComponent("LoadingMask")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_YieldChart = _resolveComponent("YieldChart")!
  const _component_PositionPanel = _resolveComponent("PositionPanel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["category-view", _ctx.isDark ? 'dark' : 'light'])
  }, [
    _createVNode(_component_LoadingMask, {
      visible: _ctx.loading,
      text: _ctx.tran('加载中，请稍候…'),
      isDark: _ctx.isDark
    }, null, 8, ["visible", "text", "isDark"]),
    (!_ctx.loading && !_ctx.strategyList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Nodata, {
            mode: "vertical",
            customdesc: _ctx.tran('暂无策略'),
            pagetheme: _ctx.isDark ? 'dark' : 'light'
          }, null, 8, ["customdesc", "pagetheme"])
        ]))
      : (_ctx.strategyList.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategyList, (sub) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sub.code,
                  class: _normalizeClass(["sub-tab-item", { active: _ctx.activeSubTab === sub.code }]),
                  onClick: ($event: any) => (_ctx.activeSubTab = sub.code)
                }, _toDisplayString(sub.name), 11, _hoisted_3))
              }), 128)),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.activeStrategy && _ctx.activeStrategy.hasGroupPermission === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.tran('解锁后查看')), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.tran('您暂时没有查看权限，可以去App上订阅或者开通铂金会员查看完整策略哦 ~ 也可直接去联系您的客户经理咨询。')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(["chart-panel", { 'no-permission': _ctx.activeStrategy && _ctx.activeStrategy.hasGroupPermission === false }])
                }, [
                  (_ctx.activeStrategy)
                    ? (_openBlock(), _createBlock(_component_YieldChart, {
                        key: 0,
                        market: _ctx.activeMarket,
                        code: _ctx.activeStrategy.code,
                        defaultRange: '1Y'
                      }, null, 8, ["market", "code"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeStrategy && _ctx.activeStrategy.hasGroupPermission === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.activeStrategy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.tran('基本信息')), 1),
                        (_ctx.activeStrategy.tags?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeStrategy.tags, (tag) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "tag-item",
                                  key: tag
                                }, _toDisplayString(tag), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.activeStrategy.profile)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.tran('策略简介')) + "：" + _toDisplayString(_ctx.activeStrategy.profile), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.tran('收益概况')), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["profit-value", _ctx.getStockClass(_ctx.activeStrategy.increaseDay1, _ctx.prefer)])
                            }, _toDisplayString(_ctx.formatPct(_ctx.activeStrategy.increaseDay1)), 3),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.tran('当日涨幅')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["stat-value", _ctx.getStockClass(_ctx.activeStrategy.yearReturns, _ctx.prefer)])
                              }, _toDisplayString(_ctx.formatPct(_ctx.activeStrategy.yearReturns)), 3),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.periodReturnsLabel(_ctx.activeStrategy.timePeriod)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatAbsPct(_ctx.activeStrategy.maxDrawDown)), 1),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.periodDrawDownLabel(_ctx.activeStrategy.timePeriod)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.holdPeriodText(_ctx.activeStrategy.holdPeriod)), 1),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.tran('调仓频率')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: _normalizeClass(["subscribe-btn", { subscribed: _ctx.activeStrategy.is_favorite === 1 }]),
                          disabled: _ctx.favoriteLoading,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
                        }, _toDisplayString(_ctx.activeStrategy.is_favorite === 1 ? _ctx.tran('已订阅') : _ctx.tran('订阅策略')), 11, _hoisted_31)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["bottom-section-wrap", { 'no-permission': _ctx.activeStrategy && _ctx.activeStrategy.hasGroupPermission === false }])
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_PositionPanel, {
                      code: _ctx.activeStrategy?.code ?? ''
                    }, null, 8, ["code"])
                  ]),
                  _createElementVNode("div", {
                    class: "table-panel history-table",
                    style: _normalizeStyle(_ctx.historyTableVars)
                  }, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.tran('历史调仓')), 1),
                    (_ctx.historyLoading && !_ctx.historyList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                      : (!_ctx.historyList.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("table", _hoisted_39, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.tran('序')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.tran('名称/代码')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.tran('调仓时间')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.tran('方向')), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_Nodata, {
                                mode: "vertical",
                                customdesc: _ctx.tran('暂无历史调仓数据'),
                                pagetheme: _ctx.isDark ? 'dark' : 'light'
                              }, null, 8, ["customdesc", "pagetheme"])
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "native-table-wrap",
                            onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHistoryScroll && _ctx.onHistoryScroll(...args)))
                          }, [
                            _createElementVNode("table", _hoisted_42, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.tran('序')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.tran('名称/代码')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.tran('调仓时间')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.tran('方向')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyList, (row, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: `${row.symbol}-${row.time}-${index}`,
                                    style: {"cursor":"pointer"},
                                    onDblclick: ($event: any) => (_ctx.goStockDetail(row))
                                  }, [
                                    _createElementVNode("td", _hoisted_45, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_46, _toDisplayString(row.name ?? '--'), 1),
                                      _createElementVNode("div", _hoisted_47, [
                                        (_ctx.isDelayed(row.market ?? ''))
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_48))
                                          : _createCommentVNode("", true),
                                        (row.market)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              class: _normalizeClass(["market-label", _ctx.isHKMarket(row.market) ? 'label-hk' : 'label-us'])
                                            }, _toDisplayString(_ctx.getMarketLabel(row.market)), 3))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_49, _toDisplayString(row.symbol ?? '--'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.fmtDate(row.time)), 1),
                                    _createElementVNode("td", _hoisted_51, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(_ctx.getStockClass(row.tradeWay === 1 ? -1 : 1, _ctx.prefer))
                                      }, _toDisplayString(row.tradeWay === 1 ? _ctx.tran('调出') : _ctx.tran('调入')), 3)
                                    ])
                                  ], 40, _hoisted_44))
                                }), 128)),
                                (_ctx.historyLoading)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.tran('加载中')) + "...", 1)
                                    ]))
                                  : (!_ctx.historyHasMore)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.tran('没有更多了')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ], 32))
                  ], 4)
                ]),
                (_ctx.activeStrategy && _ctx.activeStrategy.hasGroupPermission === false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}